import gql from "graphql-tag";

import BrandFragment from "./brand.fragment";

const CartFragment = gql`
  fragment CartFragment on Cart {
    billingAddress {
      city
      company
      country {
        id
        name
      }
      firstName
      id
      lastName
      postcode
      street
      street2
      telephone
    }
    coupon {
      code
      amount
      description
    }
    deliveryAddress {
      city
      company
      country {
        id
        name
      }
      firstName
      id
      lastName
      postcode
      street
      street2
      telephone
    }
    deliveryMode {
      id
      relayPointId
      price
      name
    }
    estimatedShipping {
      mode
      price
    }
    giftCards {
      id
      code
      amount
    }
    giftMessage
    id
    infoMessages
    errorMessages
    errorCodes
    items {
      product {
        actualPrice
        category
        id
        ean
        brand {
          ...BrandFragment
        }
        name
        url
        originalPrice
        weight
        volume
        image
        sku
        productFamily
        productSubFamily
        outOfStock
        infoMessages
        errorMessages
        errorCodes
      }
      quantity
    }
    paymentMethod {
      id
      label
    }
    rewards {
      currentIndex
      items {
        label
        iconName
      }
    }
    paymentFormData {
      submitUrl
      formData {
        key
        value
      }
    }
    subTotal
    taxAmount
    total
  }
  ${BrandFragment}
`;

export default CartFragment;
